var config = {};

config.app = {};

config.app.host = 'https://api.jconnect.ru';
// config.app.host = 'http://localhost:9090'; // */
/*config.app.host = 'http://10.10.254.45:8080'; //*/
/*clear commit +1*/

module.exports = config;